// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { AlertSubImage } from "../../Utils/Alert/AlertConstants.js";
import { QuickTableEditingInfo } from "../elements/QuickTable/QuickTableMisc.js";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.js";
import { ThemeManager } from "../misc/ThemeManager.js";
import { DynProperty } from "../../Commons/DynProperty.js";
import { AlertType, AlertTypeMap } from "../../Utils/Alert/AlertType.js";
import { AlertConditionMap } from "../../Utils/Alert/AlertCondition.js";


export let AlertItem = function (alert, sessionSettings)
{
    BaseItem.call(this, sessionSettings);
    this.alert = alert;
    if (alert)
        this.ItemId = alert.AlertId;
    this.CellForeColorMap[0] = ThemeManager.CurrentTheme.TableGoldColor; //"#EDC234";
   
    this.QuickTableEditingInfoMap[1] = (function ()
    {
        return new QuickTableEditingInfo(DynProperty.ALERT_BUTTONS_GROUP);
    })();
}

AlertItem.prototype = Object.create(BaseItem.prototype);

AlertItem.prototype.ColumnCount = function ()
{
    return AlertItem.columnsParams.length;
};

AlertItem.prototype.getColumnData = function (column)
{
    let value = this.getColumnValue(column);
    let formattedValue = '';

    switch (column)
    {
        case 0:
            formattedValue = value ? value.toString() : '';
            break;

        case 1:
            formattedValue = value ? value.toString() : '';
            break;

        default:
            formattedValue =
                value === null ||
                    value === '' ||
                    value === undefined ||
                    value === NaN
                    ? Resources.getResource('general.N_A')
                    : value.toString();
    }

    return { Value: value, FormattedValue: formattedValue };
}

AlertItem.prototype.getColumnValue = function (column)
{
    let alert = this.alert;
    let instrument = alert.Instrument;
    let FormattedValue = '';

    switch (column)
    {
        case 0:
            return instrument ? instrument.DisplayName() : "";

        case 1:
            if (alert.AlertType === AlertType.CHANGE)
                FormattedValue = alert.Value.toFixed(2);
            else if (alert.AlertType === AlertType.VOLUME)
                FormattedValue = alert.Value.toString();
            else
                FormattedValue = instrument.formatPrice(alert.Value);

            let alertTypeText = Resources.getResource('panel.watchlist.' + AlertTypeMap[alert.AlertType])
            let value = alertTypeText + ' ' + Resources.getResource('screen.Alerts.Condition.' + AlertConditionMap[alert.Condition]) + ' ' + FormattedValue;
            return value ? value : '';

        default:
            return 0;
    }
}

AlertItem.prototype.GetColumnParams = function (column)
{
    let result = AlertItem.columnsParams[column];

    return result
};

AlertItem.prototype.GetImage = function (image, hover)
{
    let theme = ThemeManager.CurrentTheme;
    switch (image)
    {
        case AlertSubImage.PLAY_STOP:
            if (this.alert.Active)
                return hover ? theme.alert_stop_hover : theme.alert_stop;
            else
                return hover ? theme.alert_play_hover : theme.alert_play;

        case AlertSubImage.UPDATE:
            return hover ? theme.alert_update_hover : theme.alert_update;//this.alert.Active ? theme.alert_update_enabled : (hover ? theme.alert_update_hover : theme.alert_update);

        case AlertSubImage.CLOSE:
            return hover ? theme.alert_close_hover : theme.alert_close;
    }
    return null;
};

AlertItem.columnsParams = [
    new ColumnParams("general.Instrument", 75, 0, false, true, false),
    new ColumnParams("screen.Alerts.TableItem.Condition", 100, 0, false, true, false)
];

AlertItem.ListMenuIndex = [
    "general.Instrument",
    "screen.Alerts.TableItem.Condition"
];